import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import EditDeliverableModal from './EditDeliverableModal';
import ContractDeliverablesEditButtons from './ContractDeliverablesEditButtons';

const DeliverableAttachmentLink = ({item, isSupplier = false}) => {
    if (!item || !item.attachment_filename) {
        return null;
    }

    const url = isSupplier
        ? `/my_contracts/${item.contract_id}/deliverables/${item.id}/download`
        : `/contracts/manage_contracts/deliverable_uploads/${item.contract_id}/${item.id}`;

    return (
        <a target="_blank" href={url}>
            <i className="fa fa-cloud-download"></i> {window.__js_contracts.download_attachment}
        </a>
    );
};

export default class ContractDeliverablesEdit extends Component {
    constructor() {
        super();

        this.state = {
            deliverable_id: 0,
            items: []
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.editRow = this.editRow.bind(this);
        this.deleteRow = this.deleteRow.bind(this);
    }

    componentWillMount() {
        this.getDeliverables();
    }

    getDeliverables() {
        const url = this.props.is_supplier
            ? `/my_contracts/${this.props.contractId}/deliverables`
            : `/contracts/ajax/manage_contracts/${this.props.contractId}/deliverables`;

        axios
            .get(url)
            .then((response) => {
                this.setState({
                    items: response.data,
                });
            });
    }

    openModal() {
        this.setState({
            show_modal: true,
            deliverable_id: 0
        });
    }

    closeModal() {
        this.setState({show_modal: false}, () => {
            this.getDeliverables();
        });
    }

    editRow(id) {
        this.setState({
            show_modal: true,
            deliverable_id: id
        });
    }

    deleteRow(id) {
        let msg = window.__js_contracts.deliverable_delete_verify;

        if (this.props.contractFinalized) {
            msg = window.__js_contracts.deliverable_delete_verify_tracking_change;
        }

        if (!confirm(msg)) {
            return;
        }

        const url = this.props.is_supplier
            ? `/my_contracts/${this.props.contractId}/deliverables/${id}/delete`
            : `/contracts/ajax/manage_contracts/${this.props.contractId}/delete_deliverable/${id}`;

        axios
            .get(url)
            .then(() => {
                this.getDeliverables();
                window.location = this.props.redirect_url;
            });
    }

    render() {
        let rows = [];
        let items = this.state.items;

        if (items.length > 0) {
            for (let key in items) {
                let item = items[key];

                if (items.hasOwnProperty(key)) {
                    rows.push(
                        <tr key={item.num}>
                            <td>{item.num}</td>
                            <td>{item.title}</td>
                            <td>{item.deadline_formatted}</td>
                            <td>
                                <DeliverableAttachmentLink
                                    item={item}
                                    isSupplier={this.props.is_supplier}
                                />
                            </td>
                            {
                                this.props.has_supplier_deliverables
                                    ?
                                    <td>{item.created_by_supplier ? window.__js_general.yes_literal : window.__js_general.no_literal}</td>
                                    : null
                            }
                            <td className={(this.props.readonly ? " hidden" : "")}>
                                <ContractDeliverablesEditButtons
                                    item={item}
                                    isSupplier={this.props.is_supplier}
                                    editRow={this.editRow}
                                    deleteRow={this.deleteRow}
                                />
                            </td>
                        </tr>
                    );
                }
            }
        } else {
            let msg = window.__js_contracts.no_deliverables_found;

            rows.push(
                <tr key="0">
                    <td colSpan="10">
                        <em>{msg}</em>
                    </td>
                </tr>
            );
        }

        return (
            <div>
                <div className="table-responsive">
                    <table className="table table-striped table-hover table-bordered">
                        <thead>
                        <tr>
                            <th>Α/Α</th>
                            <th>{window.__js_contracts.deliverable_name}</th>
                            <th>{window.__js_contracts.deliverable_date}</th>
                            <th>{window.__js_contracts.attached_file}</th>
                            {
                                this.props.has_supplier_deliverables
                                    ? <th>{window.__js_contracts.posted_by_supplier}</th>
                                    : null
                            }
                            <th className={(this.props.readonly ? " hidden" : "")}>
                                {window.__js_contracts.actions}
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {rows}
                        </tbody>
                    </table>
                </div>
                <EditDeliverableModal id={this.state.deliverable_id}
                                      is_supplier={this.props.is_supplier}
                                      contractId={this.props.contractId}
                                      showModal={this.state.show_modal}
                                      redirect_url={this.props.redirect_url}
                                      closeCallback={this.closeModal}/>
            </div>
        );
    }
}

if (document.getElementById("contract-deliverables")) {
    let element = document.getElementById("contract-deliverables");
    let csrf_token = element.getAttribute("data-csrf-token");
    let contract_id = element.getAttribute("data-contract-id");
    let contract_finalized = element.getAttribute("data-contract-finalized");
    let redirect_url = element.getAttribute("data-redirect-url");
    let is_supplier = (element.getAttribute("data-is-supplier") === "1");
    let has_supplier_deliverables = (element.getAttribute("data-has-supplier-deliverables") === "1");
    let readonly = (element.getAttribute("data-readonly") === "1");

    ReactDOM.render(
        <ContractDeliverablesEdit
            csrfToken={csrf_token}
            contractId={contract_id}
            contractFinalized={contract_finalized}
            redirect_url={redirect_url}
            is_supplier={is_supplier}
            has_supplier_deliverables={has_supplier_deliverables}
            readonly={readonly}
        />,
        element
    );
}